import React,{useEffect} from "react";
import { Button, Tooltip, Spin } from "antd";
import "./icon.css";

const HoverIcon =({ icon, onClick, tooltip, color, hoverBgColor, disabled = false, hoverColor, isLoading }) => {
  return (
    <Tooltip title={tooltip}>
      <Button
        type="text"
        loading={isLoading}
        disabled={disabled || isLoading}
        icon={
          isLoading ? (
            <Spin size="small" />
          ) : (
            React.cloneElement(icon, { style: { fontSize: "24px" } })
          )
        }
        className="custom-hover-btn"
        style={{
          "--default-color": disabled ? "gray" : color,
          "--hover-bg-color": hoverBgColor,
          "--hover-color": hoverColor,
          transition: "background-color 0.3s, color 0.3s",
        }}
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default HoverIcon;
